import service from '@/utils/axios-v2'

export function getSubscriptions(token) {
  return service({
    url: "/fleet/order/get/billing/list",
    method: "get",
    headers: { "portal-token": token }
  })
}
export function checkV1OrV2() {
  return service({
    url: '/fleet/onboard-process/get/billing/type',
    method: "get",
    headers: {
      "Content-Type": "application/json",
      "portal-token": true,
    }
  })

}
export function getLBSiteUnitPrice() {
  return service({
    url: '/fleet/commodity/get/tl/commodity',
    method: 'get'
  })
}

export function getCurrentPackage() {
  return service({
    url: '/fleet/order/get/tl/bills',
    method: 'get'
  })
}

export function firstOrder(data) {
  return service({
    url: '/fleet/order/self/generate/order',
    method: 'post',
    data
  })
}

export function changeOrder(data) {
  return service({
    url: '/fleet/order/change/order',
    method: 'post',
    data
  })
}

export function getSeatsNumber() {
  return service({
    url: '/fleet/order/get/product/info',
    method: 'get'
  })
}
export function getDriverCommandSeatsNumber() {
  return service({
    url: '/fleet/order/get/driver/product/info',
    method: 'get'
  })
}
export function getCommandSeatsNumber() {
  return service({
    url: '/fleet/order/get/product',
    method: 'get'
  })
}


export function getAssignOperatorList(data) {
  return service({
    url: '/fleet/user/get/assign/info',
    method: 'post',
    data
  })
}

export function assignLoadBoard(data) {
  return service({
    url: '/fleet/user/assign/load_board',
    method: 'post',
    data
  })
}

export function assignOperator(data) {
  return service({
    url: '/fleet/user/batch/assign/site',
    method: 'post',
    data
  })
}

export function getUpcomingBillingInfo() {
  return service({
    url: '/fleet/order/get/upcoming/billing',
    method: 'get'
  })
}

export function getBillingDetails(params) {
  return service({
    url: '/fleet/order/get/upcoming/billing/detail',
    method: 'get',
    params
  })
}

export function getBillingList(data) {
  return service({
    url: '/fleet/order/pay/records/v2',
    method: 'post',
    data
  })
}

export function getDialerAssignSeats() {
  return service({
      url: '/fleet/dialer/get/assign/seats',
      method: 'get',
    })
}

export function assignDialer(data) {
  return service({
      url: '/fleet/dialer/assign/seats',
      method: 'post',
      data
    })
}

export function cancelSubscription(data) {
  return service({
    url: '/fleet/order/collect/feedback',
    method: 'post',
    data
  })
}
